import { u_ } from "@pressmedia/webappbase";
import $ from "jquery";

export default {
	/**
	 * ajaxリクエスト送信
	 * @param {String} methodName: called method name
	 * @param {Object} ajaxSetting: request setting
	 * @param {Function} cb: callback function (@arg1: err, @arg2: responce)
	 * @returns {Promise}
	 */
	async _sendRequest(methodName, ajaxSetting, cb) {
		const def = {
			endPoint: "",
			type: "GET",
			dataType: "json",
			timeout: this.app.config.ajaxTimeoutTime || 5000
		};
		
		if( u_.isObject(ajaxSetting) ) {
			ajaxSetting = Object.assign(def, ajaxSetting);
		} else {
			ajaxSetting = def;
		}
		
		u_.isFunction(cb) || (cb = err => {});
		
		if(!ajaxSetting.url) {
			if(!this.apiBaseUrl) {
				const err = {
					code: NaN,
					messages: ["'url' is not defined."],
					method: methodName
				};
				
				return Promise.all([cb(err)]).catch().then(() => Promise.reject(err));
			}
			
			ajaxSetting.url = `${this.apiBaseUrl}/` + this.getDataKey();
			
			if(ajaxSetting.endPoint) {
				ajaxSetting.url = ajaxSetting.url.replace(/\/$/, '') + `/${ajaxSetting.endPoint}`;
			}
		}
		
		return new Promise(resolve => {
			$.ajax(ajaxSetting).then((response, textStatus, xhr) => {
				// success
				!response && (response = {});
				Promise.all([cb(null, response, xhr, textStatus)])
				.then(() => resolve({ error: null, response, xhr, textStatus }))
				.catch(() => resolve({ error: true, xhr, textStatus }));
				
			}, (...args) => {
				// error
				const xhr = args[0];
				const textStatus = args[1];
				args.unshift(methodName);
				
				let error = this.ajaxErrorCallback(...args) || xhr.responseText;
				let response = null;
				
				if(error) {
					!!error.response && (response = error.response);
				} else {
					error = true;
				}
				
				Promise.all([
					cb(error, response, xhr, textStatus)
				]).catch().then(() => resolve({ error, response, xhr, textStatus }));
			});
		});
	}
};
